import {useAppSelector} from './reduxHooks';
import {selectStoreType} from '../slices/storesSlice';
import {useGetStoreDetailsQuery} from '../api/storesApi';
import {useStoreSlug} from './useStoreSlug';

interface UseStoreType {
  isStoreTypeGroupOrder: boolean;
  isStoreTypeSelfServe: boolean;
  getStoreTypeName: string;
}

export const useStoreType = (): UseStoreType => {
  const urlSlug = useStoreSlug();
  useGetStoreDetailsQuery(urlSlug);
  const storeType = useAppSelector(selectStoreType);

  const isStoreTypeGroupOrder = storeType === 'event';

  const isStoreTypeSelfServe = storeType === 'selfServe';

  const getStoreTypeName = isStoreTypeSelfServe ? 'Store' : 'Group Order';

  return {isStoreTypeGroupOrder, isStoreTypeSelfServe, getStoreTypeName};
};

export default useStoreType;
